import { Button, Div, FormBuilder, KeyboardAwareArea, Label, Touchable } from "@grassrootly/rn-core";
import { Logo } from "../../layout/components/logo";
import { useRegister } from "./useRegister";
import { registerForm } from "./Register.types";
import { Platform, ScrollView, Text } from "react-native";

export default function RegisterScreen() {
  const { goToLogin, loading, register, insents } = useRegister();
  return (
    <Div
      classNames={[
        "flex1",
        "borderPrimary",
        "bgNeutralDarkerDark",
        "p16",
        `pb-{${insents.bottom + 16 + (Platform.OS == "web" ? 16 : 0)}}`,
        "h100",
      ]}
    >
      <KeyboardAwareArea>
        <ScrollView style={{ flex: 1 }} showsVerticalScrollIndicator={false}>
          <Div classNames={["flex1", "alignItemsCenter", "justifyContentCenter", "pt-{64}", "ph16"]}>
            <Logo width={100} height={100} />
            <Text style={{ color: "#1ABC6C", fontSize: 32, fontWeight: "bold", marginTop: 8 }}>
              eqipa
            </Text>
            <Div classNames={["mt-{20}", "w-{100%}", "maxW-{300}", "flex1"]}>
              <FormBuilder
                form={registerForm}
                onSubmit={register}
                submitControl={(submit) => (
                  <>
                    <Button
                      title="Register"
                      onPress={submit}
                      type="button"
                      classNames={["btn", "btnBlock", "btnPrimary", "mt-{22}"]}
                      isLoading={loading}
                      disabled={loading}
                    />
                    <Touchable onPress={goToLogin}>
                      <Label type="l3Regular" classNames={["underline", "textCenter", "mt-{4}"]}>
                        Already have an account? Login here.
                      </Label>
                    </Touchable>
                  </>
                )}
                submitFormOnEnter={true}
              />
            </Div>
          </Div>
        </ScrollView>
      </KeyboardAwareArea>
    </Div>
  );
}
